import { IFeed } from '@interfaces/feed';
import { useSelector } from 'react-redux';
import dynamic from 'next/dynamic';
import {
  useState
} from 'react';
import { feedService } from '@services/feed.service';
import { wrapEmojis } from '@lib/string';
import style from './card-middle.module.scss';

const FeedSlider = dynamic(() => import('./post-slider'));
const ScheduledStreamingContent = dynamic(() => import('./scheduled-streaming'));
const LockContentMiddle = dynamic(() => import('./lock-content-middle'));
const FeedPolls = dynamic(() => import('./post-polls-list'));

interface IProps {
  feed: IFeed;
  priority: boolean;
}

export default function PostCardMiddle({ feed, priority }: IProps) {
  const user = useSelector((state: any) => state.user.current);
  const [data, setData] = useState(feed);

  // Guest users and authenticated users can view:
  // 1. Free content (!isSale)
  // 2. Purchased content (isBought)
  // 3. Text posts (always visible)
  // 4. Scheduled streaming (always visible)
  // 5. Sale items with no price (free but requires follow)
  let canView = !data.isSale
    || data.isBought
    || ['text', 'scheduled-streaming'].includes(feed.type)
    || (data.isSale && !data.price);

  // Only block performers from viewing other performers' content
  if (user._id && user.isPerformer && `${user._id}` !== `${data.fromSourceId}`) {
    canView = false;
  }

  return (
    <div className={style['feed-container']}>
      {/* eslint-disable-next-line react/no-danger */}
      <div className={style['feed-text']} dangerouslySetInnerHTML={{ __html: wrapEmojis(data.text) }} />
      {data.polls && data.polls.length > 0 && <FeedPolls feed={data} />}
      {data.type === 'scheduled-streaming' && <ScheduledStreamingContent feed={data} />}
      {!['text', 'scheduled-streaming'].includes(feed.type) && (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
          {canView && feed?.files?.length ? (
            <FeedSlider
              feed={data}
              priority={priority}
            />
          ) : (
            <LockContentMiddle
              feed={data}
              onPuchaseSuccess={async () => {
                const { data: newFeed } = await feedService.findOne(data._id);
                setData(newFeed);
              }}
            />
          )}
        </>
      )}
    </div>
  );
}
